import { render } from "./OrderAdditionalServicesUpdate.vue?vue&type=template&id=2381b9b8&scoped=true&ts=true"
import script from "./OrderAdditionalServicesUpdate.vue?vue&type=script&lang=ts"
export * from "./OrderAdditionalServicesUpdate.vue?vue&type=script&lang=ts"

import "./OrderAdditionalServicesUpdate.vue?vue&type=style&index=0&id=2381b9b8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2381b9b8"]])

export default __exports__